var infowindow;

function handleClickShopLink (event) {
  let id = event.target.dataset.id;
  let map = googleMaps.getMap('find-a-dealer');
  let marker = map.getMarker(id + '-shopAddress')
  if (infowindow) {
    infowindow.close()
  }
  infowindow = map.getInfoWindow(id + '-shopAddress')
  let latLng = marker.getPosition()
  infowindow.open(map, marker)
  map.center(latLng)
  if (window.innerWidth < 768) {
    window.scrollTo(0, document.querySelector('#find-a-dealer').offsetTop)
  }
}

export function initialize() {
  let shopLinks = document.querySelectorAll('.js-center-map')
  Array.prototype.forEach.call(shopLinks, function(el, i){
    el.addEventListener('click', handleClickShopLink, false)
  })
}
